import Vue from 'vue'
var striptags = require('striptags')

Vue.filter('stripHtml', function(value) {
  return striptags(value)
})
